export default "__VITE_ASSET__13089453__"